import { render } from "./valores.vue?vue&type=template&id=43c768c2&scoped=true"
import script from "./valores.vue?vue&type=script&lang=js"
export * from "./valores.vue?vue&type=script&lang=js"

import "./valores.vue?vue&type=style&index=0&id=43c768c2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-43c768c2"

export default script